@if (showLdr) {
<ds-loading></ds-loading>
}
<!-- Brand Header -->
<div
  class="relative overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex flex-wrap gap-2 items-center justify-between px-5 py-1 relative"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          ></path>
        </svg>
      </div>
      <div>
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <!-- <app-header [headerDtls]="headerDtls"></app-header> -->
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Reports & Analytics
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Category Filters -->
<div class="category-section">
  <div class="category-grid">
    @for (c of ctgrylst; track c; let i = $index) {
    <button class="category-btn" (click)="changeCtgry(c)">
      <span class="category-icon">{{ c.rpt_ctgry_cd }}</span>
      <span class="category-text">{{ c.rpt_ctgry_nm }}</span>
    </button>
    }
    <button class="category-btn all-btn" (click)="getReprtLst()">
      <span class="category-icon all-icon">*</span>
      <span class="category-text">All Reports</span>
    </button>
  </div>

  <!-- Search Bar -->
  <div class="search-wrapper">
    <nz-input-wrapper>
      <input
        type="text"
        class="search-input"
        nz-input
        [(ngModel)]="searchText"
        placeholder="Search report here..."
        [ngModelOptions]="{ standalone: true }"
      />
    </nz-input-wrapper>
  </div>
</div>

<!-- Report Groups -->
<div class="reports-container">
  @for (d of rptLst | filter:searchText; track d; let gi = $index) {
  <div class="report-group">
    <div class="report-group-header">
      <i
        nz-icon
        [nzType]="getGroupIcon(gi)"
        nzTheme="outline"
        class="group-icon"
      ></i>
      <h2>{{ d.grp_nm }}</h2>
    </div>
    <div class="report-cards-grid">
      @for (f of d.opts; track f; let ci = $index) {
      <div [ngClass]="f.rpt_shw_in ? 'report-card-wrapper' : 'd-n'">
        <div class="report-card" (click)="gotoRpt(f, d)">
          <div class="report-card-icon" [ngClass]="'icon-color-' + (ci % 6)">
            <i nz-icon [nzType]="getCardIcon(ci)" nzTheme="outline"></i>
          </div>
          <div class="report-card-content">
            <div class="report-label">{{ f.rpt_nm }}</div>
            <div class="report-sub-text">{{ f.rpt_dscn_tx }}</div>
          </div>
          <div class="report-card-arrow">
            <i nz-icon nzType="right" nzTheme="outline"></i>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>

<!-- Skeleton Loader -->
@if (loader) {
<div class="reports-container">
  @for (i of [0,1,2]; track i) {
  <div class="report-group">
    <div class="report-group-header">
      <nz-skeleton-element
        nzType="input"
        [nzActive]="true"
        [nzSize]="'small'"
        style="width: 200px"
      >
      </nz-skeleton-element>
    </div>
    <div class="report-cards-grid">
      @for (i of [0,1]; track i) {
      <div class="report-card-wrapper">
        <div class="report-card">
          <nz-skeleton-element
            nzType="input"
            [nzActive]="true"
            [nzSize]="'small'"
            style="width: 200px"
          >
          </nz-skeleton-element>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
}
